import { Primitive } from './Primitive';
import { Type } from './Type';
export class ArrayND extends Primitive {
    constructor(buffer, dataType, shape) {
        super(Type.ArrayND);
        this.buffer = buffer;
        this.dataType = dataType;
        this.shape = shape;
    }
}
/* istanbul ignore next */
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (ArrayND) {
    let DataType;
    (function (DataType) {
        DataType["Boolean"] = "bool";
        DataType["Float16"] = "float16";
        DataType["Float32"] = "float32";
        DataType["Float64"] = "float64";
        DataType["Integer16"] = "int16";
        DataType["Integer32"] = "int32";
        DataType["Integer64"] = "int64";
        DataType["Integer8"] = "int8";
        DataType["UnsignedInteger16"] = "uint16";
        DataType["UnsignedInteger32"] = "uint32";
        DataType["UnsignedInteger64"] = "uint64";
        DataType["UnsignedInteger8"] = "uint8";
    })(DataType = ArrayND.DataType || (ArrayND.DataType = {}));
})(ArrayND || (ArrayND = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXJyYXlORC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvQXJyYXlORC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBQ3ZDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxRQUFRLENBQUE7QUFFN0IsTUFBTSxPQUFPLE9BQVEsU0FBUSxTQUFTO0lBS3BDLFlBQ0UsTUFBMEIsRUFDMUIsUUFBMEIsRUFDMUIsS0FBa0I7UUFFbEIsS0FBSyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTtRQUNuQixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtRQUNwQixJQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQTtRQUN4QixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtJQUNwQixDQUFDO0NBQ0Y7QUFFRCwwQkFBMEI7QUFDMUIsMkRBQTJEO0FBQzNELFdBQWlCLE9BQU87SUFjdEIsSUFBWSxRQWFYO0lBYkQsV0FBWSxRQUFRO1FBQ2xCLDRCQUFnQixDQUFBO1FBQ2hCLCtCQUFtQixDQUFBO1FBQ25CLCtCQUFtQixDQUFBO1FBQ25CLCtCQUFtQixDQUFBO1FBQ25CLCtCQUFtQixDQUFBO1FBQ25CLCtCQUFtQixDQUFBO1FBQ25CLCtCQUFtQixDQUFBO1FBQ25CLDZCQUFpQixDQUFBO1FBQ2pCLHdDQUE0QixDQUFBO1FBQzVCLHdDQUE0QixDQUFBO1FBQzVCLHdDQUE0QixDQUFBO1FBQzVCLHNDQUEwQixDQUFBO0lBQzVCLENBQUMsRUFiVyxRQUFRLEdBQVIsZ0JBQVEsS0FBUixnQkFBUSxRQWFuQjtBQUNILENBQUMsRUE1QmdCLE9BQU8sS0FBUCxPQUFPLFFBNEJ2QiJ9